var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_131017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 60L54.0331 60C55.2274 60 56.308 59.2915 56.7843 58.1962L65.5024 38.1444C65.8306 37.3896 66 36.5752 66 35.7521L66 30C66 28.3431 64.6569 27 63 27L40 27L43.8809 9.53587C43.9551 9.20211 43.8536 8.85359 43.6118 8.61183L42.5 7.5L24.8787 25.1213C24.3161 25.6839 24 26.447 24 27.2426L24 57C24 58.6569 25.3431 60 27 60Z",
    stroke: "#3B7A80",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 62,
    width: 10,
    height: 35,
    transform: "rotate(-180 14 62)",
    fill: "#3B7A80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M27 60L54.0331 60C55.2274 60 56.308 59.2915 56.7843 58.1962L65.5024 38.1444C65.8306 37.3896 66 36.5752 66 35.7521L66 30C66 28.3431 64.6569 27 63 27L40 27L43.8809 9.53587C43.9551 9.20211 43.8536 8.85359 43.6118 8.61183L42.5 7.5L24.8787 25.1213C24.3161 25.6839 24 26.447 24 27.2426L24 57C24 58.6569 25.3431 60 27 60Z",
    fill: "#3B7A80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_131017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.f2648a148dd3c68f5ab269d96c8c8550.svg";
export { ForwardRef as ReactComponent };